import { Attribute, AttributeProperty } from "react-builder";
import { CarouselItemStateAttributes } from "./CarouselItemState";

export class CarouselItemThemeAttributes extends Attribute {
  @AttributeProperty({ type: "Object", cssTarget: "" })
  static: CarouselItemStateAttributes = new CarouselItemStateAttributes();
  @AttributeProperty({ type: "Object", cssTarget: ":hover" })
  hover: CarouselItemStateAttributes = new CarouselItemStateAttributes();
}
